module.exports = __webpack_public_path__ + "files/197a42babfd63f531ff006a2982d1c99.svg";